/// <reference path="../../typings/index.d.ts" />

module monitoringApp.controllers {

    interface IBrowserObject {
        selected: string,
        id: string
    }

    class CaseDetailsController {
        private browsers: Array<IBrowserObject>;
        private caseId: number;
        private pollId: number;
        private dateFilter: string = "";
        private mainChartData: Array<Number> = [0, 0, 0];
        private mainChartColors: string[] = ["#4CAF50", "#f7464a", "#eeeeee"];
        private runSuiteResult: entities.IRunSuiteResult;
        private historyResult: entities.ICaseHistoryResult;
        private statusFilter: string = 'all';
        private strings = {
            browserAlertTitle: "",
            browserAlertContent: ""
        };
        private requestProgress = false;
        private dayPassedData: Array<[number, number]> = [];
        private dayFailedData: Array<[number, number]> = [];
        private dayRunsData: Array<[number, number]> = [];
        private dayPassedPerc: Array<[number, number]> = [];
        private dayFailedPerc: Array<[number, number]> = [];
        private hourFailedData: Array<[number, number]> = [];
        private submitUrl: string;
        private submitUrlBs: string;


        constructor(private formService: common.FormService, private dataAccessService: common.DataAccessService,
            private $mdDialog: ng.material.IDialogService, private $timeout) { }

        private browserStackBrowsers;
        private browserStackBrowser: Number;
        private _bsBrowsers: string;
        get bsBrowsers() {
            return this._bsBrowsers;
        }
        set bsBrowsers(brs) {
            this._bsBrowsers = brs;
            this.browserStackBrowsers = JSON.parse(brs).filter((b => {
                return b.id != '';
            }))
        }


        private submitFrmTestCase = ($event) => {
            $event.preventDefault();
            var selectedBrowsers = this.selectedBrowsers();
            if (selectedBrowsers.length == 0) {
                this.popupBrowserAlert();
                return;
            }

            this.formService.submitForm(this.submitUrl, { "browsers[]": selectedBrowsers }).then(
                //@ts-ignore
                (data: entities.IStartSuiteResult) => {
                    if (data.testSuiteRunId) {
                        this.pollResults(data.testSuiteRunId);
                    }
                }
            );
        }

        private submitFrmBSTestCase = ($event) => {
            $event.preventDefault();
            if (!this.browserStackBrowser) {
                this.popupBrowserAlert();
                return;
            }
            this.formService.submitForm(this.submitUrlBs, { "browsers[]": this.browserStackBrowser }).then(
                //@ts-ignore
                (data: entities.IStartSuiteResult) => {
                    if (data.testSuiteRunId) {
                        this.pollResults(data.testSuiteRunId);
                    }
                }
            );
        }

        private popupBrowserAlert = () => {
            this.$mdDialog.show(
                this.$mdDialog.alert()
                    .parent(angular.element(document.querySelector('.case-details')))
                    .clickOutsideToClose(true)
                    .title(this.strings.browserAlertTitle)
                    .textContent(this.strings.browserAlertContent)
                    .ok('OK')
            );
        };

        private selectedBrowsers(): Array<number> {
            var browsers = [];
            angular.forEach(this.browsers, (browser) => {
                if (browser.selected === "1")
                    browsers.push(browser.id);
            })
            return browsers;
        }

        static $inject = ['formService', 'dataAccessService', '$mdDialog', '$timeout'];

        private getCaseRun = (testSuiteRunId): void => {
            var resource = this.dataAccessService.getSuiteRunResult(testSuiteRunId);
            resource.get((data: monitoringApp.entities.IRunSuiteResult) => {
                console.log(data);
                this.runSuiteResult = data;
            });
        }

        private getHistory = (): void => {
            this.requestProgress = true;
            this.dataAccessService.getCaseHistory(this.caseId, this.dateFilter).then((data) => {
                this.historyResult = data;
                this.mainChartData = [data.summary.passed, data.summary.failed, data.summary.runs - data.summary.failed - data.summary.passed];
                this.createCharts(data);
                this.requestProgress = false;
            })

        }

        private pollResults = (testSuiteRunId: number): void => {
            clearInterval(this.pollId);
            this.getCaseRun(testSuiteRunId);
            this.pollId = setInterval(() => {
                this.getCaseRun(testSuiteRunId);
            }, 2000);
        }

        private createChartData = (data) => {

            this.dayFailedData.length = 0;
            this.dayPassedData.length = 0;
            this.dayRunsData.length = 0;
            this.dayPassedPerc.length = 0;
            this.dayFailedPerc.length = 0;
            this.hourFailedData.length = 0;


            angular.forEach(data.byDay, (value, key) => {
                this.dayPassedData.push([key, value.passed]);
                this.dayFailedData.push([key, value.failed]);
                this.dayRunsData.push([key, value.runs]);
                this.dayPassedPerc.push([key, value.runs != 0 ? value.passed / value.runs * 100 : 0]),
                    this.dayFailedPerc.push([key, value.runs != 0 ? value.failed / value.runs * 100 : 0])
            });


            angular.forEach(data.byHour, (value, key) => {
                this.hourFailedData.push([key, value.failed]);
            });



        };

        private refreshCharts = () => {
            this.$timeout(function () {
                window.dispatchEvent(new Event('resize'));
            }, 0);
        }


        private createCharts = (data) => {
            this.createChartData(data);
            this.refreshCharts();
        }


    }

    angular.module("ultimateMonitoringApp").controller("caseDetailsController", CaseDetailsController);
}